// extracted by mini-css-extract-plugin
module.exports = {"container":"_2wmVr3x78OUPh0nNnvBJ8m","text":"_1k-ENuKWiqrt-qv_TJZ4sC","checkbox":"_25sNrandSn5Z0E5rUcibaG","selected":"_2broXppnlDzKtLQ8FeXj8g"};